import React, { Component } from "react";
import { connect } from "react-redux";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { getEvolutionPlanCompletionRatio } from "actions";
import { Trans } from "react-i18next";

am4core.useTheme(am4themes_animated);

class EvolutionPlanTrainingCompletionRatio extends Component {
  state = {
    isManager: localStorage.getItem("roles").includes("Manager"),
    error: null,
    employeeQualification: 0,
    dealerQualification: 0,
  };

  chartDiv = React.createRef();
  bbgv = React.createRef();
  bbgv2 = React.createRef();

  deptSelectCombo = React.createRef();
  chart = null;

  unsuccessColor = "#e42c3b";
  averageColor = "#ff7f00";
  successColor = "#09b409";

  componentDidMount() {
    this.fetchStats();
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.employeeId !== this.props.employeeId) {
      this.fetchStats();
    }
  };

  componentWillUnmount() {
    if (this.chart) this.chart.dispose();
  }

  fetchStats = () => {
    this.props.getEvolutionPlanCompletionRatio(
      this.props.employeeId,
      this.onBegin,
      this.onSuccess,
      this.onError
    );
  };
  onBegin = () => {
    this.props.onProcessBegin();
  };
  onSuccess = () => {
    this.props.onProcessEnd();

    this.setState({
      employeeQualification: Number(
        this.props.evolutionPlan.completionRatio.employeeQualification
      ),
      dealerQualification: Number(
        this.props.evolutionPlan.completionRatio.dealerQualification
      ),
    });

    this.trainingCompletenessChart();
  };
  onError = (err) => {
    console.dir(err);
    this.props.onProcessEnd();
  };

  getColorCode(subj) {
    if (subj < 50) {
      return this.unsuccessColor;
    } else if (subj >= 50 && subj < 85) {
      return this.averageColor;
    } else {
      return this.successColor;
    }
  }

  trainingCompletenessChart = () => {
    if (this.chart) this.chart.dispose();

    let lineColor1;
    let lineColor2;

    am4core.useTheme(am4themes_animated);
    // create chart
    this.chart = am4core.create(this.chartDiv.current, am4charts.GaugeChart);
    this.chart.innerRadius = am4core.percent(72);
    this.chart.paddingTop = am4core.percent(0);
    this.chart.paddingLeft = am4core.percent(0);
    this.chart.paddingRight = am4core.percent(0);
    this.chart.paddingBottom = am4core.percent(0);

    var axis = this.chart.xAxes.push(new am4charts.ValueAxis());
    axis.min = 0;
    axis.max = 100;
    axis.renderer.innerRadius = 10;
    axis.strictMinMax = true;
    axis.renderer.labels.template.disabled = true;
    axis.renderer.ticks.template.disabled = true;
    axis.renderer.grid.template.disabled = true;
    var range0 = axis.axisRanges.create();
    range0.value = 0;
    range0.endValue = this.state.employeeQualification;
    range0.axisFill.fillOpacity = 1;
    range0.axisFill.fill = am4core.color(
      this.getColorCode(this.state.employeeQualification)
    );
    lineColor1 = this.getColorCode(this.state.employeeQualification);
    range0.axisFill.radius = am4core.percent(100);
    range0.axisFill.innerRadius = am4core.percent(60); // set it to >100 if you'd like to have some gap between fills
    range0.grid.disabled = true;
    var range1 = axis.axisRanges.create();
    range1.value = 0;
    range1.endValue = 100;
    range1.axisFill.fillOpacity = 1;
    range1.axisFill.fill = am4core.color("#DADADA");
    range1.axisFill.radius = am4core.percent(100);
    range1.axisFill.innerRadius = am4core.percent(60); // set it to >100 if you'd like to have some gap between fills
    range1.grid.disabled = true;
    var axis2 = this.chart.xAxes.push(new am4charts.ValueAxis());
    axis2.min = 0;
    axis2.max = 100;
    axis2.strictMinMax = true;
    axis2.renderer.labels.template.disabled = true;
    axis2.renderer.ticks.template.disabled = true;
    axis2.renderer.grid.template.disabled = true;
    axis2.renderer.ticks.template.disabled = true;
    axis2.renderer.ticks.template.strokeOpacity = 0;
    axis2.renderer.ticks.template.strokeWidth = 0;
    axis2.renderer.ticks.template.length = 0;
    var range2 = axis2.axisRanges.create();
    range2.value = 0;
    range2.endValue = 100;
    range2.axisFill.fillOpacity = 1;
    range2.axisFill.fill = am4core.color("#2d96cd");
    lineColor2 = "#2d96cd";
    range2.axisFill.radius = am4core.percent(117);
    range2.axisFill.innerRadius = am4core.percent(110); // set it to >100 if you'd like to have some gap between fills
    range2.grid.disabled = true;
    var range3 = axis2.axisRanges.create();
    range3.value = this.state.dealerQualification;
    range3.endValue = 100;
    range3.axisFill.fillOpacity = 1;
    range3.axisFill.fill = am4core.color("#DADADA");
    range3.axisFill.radius = am4core.percent(117);
    range3.axisFill.innerRadius = am4core.percent(110); // set it to >100 if you'd like to have some gap between fills
    range3.grid.disabled = true;
    var hand = this.chart.hands.push(new am4charts.ClockHand());
    hand.axis = axis2;
    hand.innerRadius = am4core.percent(10);
    hand.startWidth = 0;
    hand.pin.disabled = true;
    hand.value = 0;
    hand.opacity = 0;
    var hand2 = this.chart.hands.push(new am4charts.ClockHand());
    hand2.axis = axis;
    hand2.innerRadius = am4core.percent(10);
    hand2.startWidth = 0;
    hand2.pin.disabled = true;
    hand2.value = 0;
    hand2.opacity = 0;
    hand.events.on("propertychanged", function (ev) {
      range2.endValue = ev.target.value;
      range3.value = ev.target.value;
    });
    hand2.events.on("propertychanged", function (ev) {
      range0.endValue = ev.target.value;
      range1.value = ev.target.value;
    });
    new am4core.Animation(
      hand,
      {
        property: "value",
        to: this.state.dealerQualification,
      },
      2000
    ).start();
    new am4core.Animation(
      hand2,
      {
        property: "value",
        to: this.state.employeeQualification,
      },
      2000
    ).start();
    if (this.state.employeeQualification < this.state.dealerQualification) {
      this.bbgv.current.style.background = lineColor1;
      this.bbgv.current.style.width = this.state.employeeQualification + "%";
      this.bbgv2.current.style.background = lineColor2;
      this.bbgv2.current.style.width = this.state.dealerQualification + "%";
    } else {
      this.bbgv.current.style.background = lineColor2;
      this.bbgv.current.style.width = this.state.dealerQualification + "%";
      this.bbgv2.current.style.background = lineColor1;
      this.bbgv2.current.style.width = this.state.employeeQualification + "%";
    }
  };

  getQualClassName = (qual) => {
    if (parseInt(qual) < 50) return "red";
    else if (qual >= 50 && qual < 85) return "orange";
    else return "green";
  };

  renderStats = () => {
    return (
      <div className="tamamlananEgitimAlani tumDepartmanlar">
        <div
          className={`egitimSayisi ${this.getQualClassName(
            this.state.employeeQualification
          )}`}
        >
          <sup>%</sup>
          {this.state.employeeQualification}
        </div>
        <div
          id="allDepChart_1"
          className="chartGraphic"
          ref={this.chartDiv}
        ></div>
        <div className="satisSonrasiOrani tekdeger">
          <sup>%</sup>
          {this.state.dealerQualification}
        </div>
        <div className="clearfix"></div>
        <div className="borderBottomGraphicBg">
          <div className="borderBottomGraphicValue1" ref={this.bbgv}></div>
          <div className="borderBottomGraphicValue2" ref={this.bbgv2}></div>
        </div>
        <ul className="infoText">
            <li>
                <Trans desc="Seçili Departman">10404</Trans>
            </li>
          </ul>
      </div>
    );
  };

  render() {
    return (
      <div className={`egitimTamamlanmaOrani ${this.props.classNames}`}>
        <div className="dashboardHeader">
          <div className="dashboardHeaderContent">
            <div className="egitimBaslik">
              <Trans desc="Eğitim Tamamlanma Oranı">10009</Trans>
            </div>
          </div>
        </div>
        <hr />
        {this.renderStats()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    evolutionPlan: state.evolutionPlan.data,
    application: state.application,
  };
};

export default connect(mapStateToProps, { getEvolutionPlanCompletionRatio })(
  containsLongRunningProcess(EvolutionPlanTrainingCompletionRatio)
);